<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH MAIL</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              icon="el-icon-circle-plus-outline"
              >thêm mới mail</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              :visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Mã">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['code']"
                          size="medium"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Tên mail">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['name']"
                          size="medium"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="code"
                label="Mã"
                min-width="200"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="Tên mail"
                min-width="250"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column> 
              <el-table-column
                prop="note"
                label="Nội dung ghi chú"
                min-width="280"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  <div :title="scope.row.note" class="cell">
                    {{ scope.row.note }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" align="center" width="150px">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="'Preview'"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
          <Preview 
            :data="dataPreview" 
            :showMail="showMail" 
            :code="dataPreDetail.code"
            :name="dataPreDetail.name"
            @back-popup="showMail = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import Preview from "./Preview.vue";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormMail";
import mushroom from "viettoc-api";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
      dataPreview: MethodService.copyObject(DataForm.dataMail),
      dataPreDetail: {
        code: '',
        name: '',
      },
      showMail: false,
      listMeta: [{
        name: undefined,
        content: undefined,
      }],
    };
  },
  components: {
    Circle4,
    Preview,
  },
  methods: {
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachMail",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      try {
        const response = await mushroom.mail_template.listAsync(dataFilter);
        if (response.result) {
          this.loading = false;
          this.mData.tableRules.data = response.result;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
        }
      } catch (e) {
        console.log(e);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
        this.loading = false;
      }
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    showMailPreview(content) {
      const dom = document.createElement('div');
      dom.innerHTML = content;
      const metas = dom.getElementsByTagName('meta');
      const arrMetas = Array.prototype.slice.call(metas);
      this.listMeta = [];
      if(arrMetas) {
        arrMetas.forEach((item) => {
          if(item.name) {
            this.listMeta.push(
              {
                name: item.name,
                content: item.content,
              }
            )
          }
        })
      };

      this.dataPreview.to = this.listMeta.find(item => item.name === 'template:toEmail') ? this.listMeta.find(item => item.name === 'template:toEmail').content : undefined;
      this.dataPreview.test.from = this.listMeta.find(item => item.name === 'template:fromEmail') ? this.listMeta.find(item => item.name === 'template:fromEmail').content : undefined;
      this.dataPreview.test.cc = this.listMeta.find(item => item.name === 'template:ccEmail') ? this.listMeta.find(item => item.name === 'template:ccEmail').content : undefined;
      this.dataPreview.test.bcc = this.listMeta.find(item => item.name === 'template:bccEmail') ? this.listMeta.find(item => item.name === 'template:bccEmail').content : undefined;
      this.dataPreview.test.replyTo = this.listMeta.find(item => item.name === 'template:replyToEmail') ? this.listMeta.find(item => item.name === 'template:replyToEmail').content : undefined;
      
      this.dataPreview.subject = dom.getElementsByTagName('title')[0] ? dom.getElementsByTagName('title')[0].innerText : undefined;
      this.dataPreview.prod.from = this.listMeta.find(item => item.name === 'template:{@env}fromEmail') ? this.listMeta.find(item => item.name === 'template:{@env}fromEmail').content : undefined;
      this.dataPreview.prod.cc = this.listMeta.find(item => item.name === 'template:{@env}ccEmail') ? this.listMeta.find(item => item.name === 'template:{@env}ccEmail').content : undefined;
      this.dataPreview.prod.bcc = this.listMeta.find(item => item.name === 'template:{@env}bccEmail') ? this.listMeta.find(item => item.name === 'template:{@env}bccEmail').content : undefined;
      this.dataPreview.prod.replyTo = this.listMeta.find(item => item.name === 'template:{@env}replyToEmail') ? this.listMeta.find(item => item.name === 'template:{@env}replyToEmail').content : undefined;
      
      const bodyHtml = dom;
      const test = bodyHtml.getElementsByTagName('img');
      const arrImgs = Array.prototype.slice.call(test);
      if(arrImgs) {
        arrImgs.forEach((item) => {
          const srcImg = this.listMeta.find(el => el.name === item.src);
          item.src = srcImg ? 'data:' + srcImg.content.slice(0, 10) + 'base64,' +  srcImg.content.slice(10): '';
        })
      };
      this.dataPreview.content = bodyHtml.innerHTML;
      this.showMail = true;
    },

    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.dataPreDetail.code = row.code;
        this.dataPreDetail.name = row.name;
        this.showMailPreview(row.content);
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatMail",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    async fn_delete(id) {
      try {
        await mushroom.mail_template.deleteAsync({ id: id });
      } catch (e) {
        console.log(e.code);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        } else {
          window.toastr.error("Đã có lỗi xảy ra. Hãy thử lại");
        }
      }
      this.fn_initTable();
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      this.$router.replace({
        name: "DanhSachMail",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["name"]) {
        this.mData.tableRules.dataSearch.value["name"] =
          this.mData.tableRules.dataSearch.value["name"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["code"]) {
        this.mData.tableRules.dataSearch.value["code"] =
          this.mData.tableRules.dataSearch.value["code"].trim();
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = "";
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_add() {
      this.$router.push({
        name: "ThemMoiMail",
      });
    },
  },
  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_initTable(this.mData.tableRules.filters);
  },
  async mounted() {},
};
</script>
<style scoped>
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}

@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
